import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useStore } from "../../../../stores/store";
import { observer } from "mobx-react-lite";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "react-i18next";
import { useEditData } from "../../../../hooks/useEditData";
import FormLayout from '../../../Generic/FormLayout';
import FormInput from '../../../Generic/FormInput';
import FormCheckbox from '../../../Generic/FormCheckbox';
import { useSetMenu } from "../../../../hooks/useSetMenu";
import useAxiosPrivate from "../../../../hooks/useAxiosPrivate";
import * as yup from "yup";

const Edit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { mainStore } = useStore();
  const axiosPrivate = useAxiosPrivate();
  const { t } = useTranslation();
  useSetMenu(mainStore.KeyFeaturesAdminMenuType, mainStore.KeyFeaturesAdminMenuNo);

  const schema = yup.object({
    titleEN: yup.string().required(t('requiredField')).max(200, t('maxLength', { max: 200 })),
    featureOrder: yup.number().required(t('requiredField')).min(1, t('minValue', { min: 1 })),
  });

  const { register, handleSubmit, formState: { errors }, setValue } = useForm({ resolver: yupResolver(schema) });
  const onSubmit = data => updateData(data);

  const { notFound, updateData } = useEditData(axiosPrivate, "/KeyFeatures", id, setValue, navigate);

  const goToList = () => {
    navigate("/Admin/KeyFeatures");
  };

  if (notFound) {
    return (
      <div className="not-found-myDiv">
        <div className="not-found-container">
          <div className="not-found-content">
            <h1>{t("pageNotFoundTitle")}</h1>
            <p>{t("noDataWithIdMessage")}</p>
            <button onClick={goToList} className="btn btn-primary">
              {t("goTo") + " " + t("list") + " " + t("keyFeatures")}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <FormLayout title={t("keyFeatureEditTitle") || "Edit Key Feature"} onSubmit={handleSubmit(onSubmit)} onCancel={() => navigate(-1)}>
      <FormInput label="order" name="featureOrder" type="number" register={register} errors={errors} colSize={2} />
      <FormInput label="iconClass" name="iconClass" register={register} errors={errors} colSize={4} />
      <FormInput label="iconBgColor" name="iconBgColor" register={register} errors={errors} colSize={3} />
      <FormInput label="iconColor" name="iconColor" register={register} errors={errors} colSize={3} />
      <FormInput label="titleEN" name="titleEN" register={register} errors={errors} colSize={12} />
      <FormInput label="titleBG" name="titleBG" register={register} errors={errors} colSize={6} />
      <FormInput label="titleSQ" name="titleSQ" register={register} errors={errors} colSize={6} />
      <FormInput label="descriptionEN" name="descriptionEN" register={register} errors={errors} colSize={12} isTextArea={true} />
      <FormInput label="descriptionBG" name="descriptionBG" register={register} errors={errors} colSize={12} isTextArea={true} />
      <FormInput label="descriptionSQ" name="descriptionSQ" register={register} errors={errors} colSize={12} isTextArea={true} />
      <FormCheckbox label="isActive" register={register} name="isActive" colSize={4} />
      <FormCheckbox label="isVisible" register={register} name="isVisible" colSize={4} />
    </FormLayout>
  );
};

export default observer(Edit);
